import { ActionAnswer } from 'src/api/quizzes/types'

export const answerActionToAnalyticsAction = (answer: ActionAnswer) => {
  switch (answer) {
    case ActionAnswer.up:
      return 'Love'
    case ActionAnswer.right:
      return 'Like'
    case ActionAnswer.left:
      return 'Meh'
    case ActionAnswer.down:
      return 'Nope'
    case ActionAnswer.skip:
      return 'Skip'
    default:
      return ''
  }
}
